"use client";

// packages/eden-icons/src/generated-from-source/ArtificialIntelligence.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var ArtificialIntelligence = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M8.278 7.338A3.666 3.666 0 0 1 6.35 9.266l-3.121 1.336a.44.44 0 0 0 0 .771L6.35 12.71a3.668 3.668 0 0 1 1.928 1.928l1.336 3.121a.44.44 0 0 0 .772 0l1.336-3.121a3.668 3.668 0 0 1 1.928-1.928l3.121-1.337a.44.44 0 0 0 0-.771l-3.12-1.336a3.668 3.668 0 0 1-1.93-1.928l-1.335-3.121a.44.44 0 0 0-.772 0l-1.336 3.12ZM10 7.128l-.343.8a5.166 5.166 0 0 1-2.717 2.717l-.8.343.8.343a5.168 5.168 0 0 1 2.717 2.717l.343.8.343-.8a5.168 5.168 0 0 1 2.717-2.717l.8-.343-.8-.343a5.166 5.166 0 0 1-2.717-2.717l-.343-.8Z", fillRule: "evenodd", clipRule: "evenodd", children: " " }),
  /* @__PURE__ */ jsx("path", { fill: color, d: "M17.307 15.102a.22.22 0 0 1 .386 0l.668 1.56a1.832 1.832 0 0 0 .964.965l1.56.668a.22.22 0 0 1 0 .386l-1.56.668a1.834 1.834 0 0 0-.964.964l-.668 1.56a.22.22 0 0 1-.386 0l-.668-1.56a1.834 1.834 0 0 0-.964-.964l-1.56-.668a.22.22 0 0 1 0-.386l1.56-.668a1.832 1.832 0 0 0 .964-.964l.668-1.56Z", children: " " })
] });
var ArtificialIntelligence_default = ArtificialIntelligence;
export {
  ArtificialIntelligence_default as default
};
